import React, { useMemo, useState } from 'react';
import { Sparkles, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useT } from '../utils/i18n';
const PHONE_NUMBER = '(206) 619-3742';
// Slogan pool — i18n keys, picked at random ONCE per page load (no in-page
// rotation). The bar reinforces brand, never promotes a discount or a
// per-customer state. Active-order tracking lives in the Hero WelcomeBack
// card now, where it's contextual to the customer's session.
const SLOGAN_KEYS = ['announce.slogan.sameDay', 'announce.slogan.bulkDelivery', 'announce.slogan.direct', 'announce.slogan.familyOwned', 'announce.slogan.realTrucks', 'announce.slogan.tacoma'] as const;
export function AnnouncementBar() {
  const t = useT();
  // Pick a single slogan key per page load. Lazy initializer keeps the
  // choice stable for the session — fresh on each visit without
  // distracting in-page rotation.
  const [sloganKey] = useState<string>(() => SLOGAN_KEYS[Math.floor(Math.random() * SLOGAN_KEYS.length)]);
  const currentSlide = useMemo(() => ({
    key: sloganKey,
    content: <span className="flex items-center gap-1.5 min-w-0" data-id="element-157" data-mp="aad9swj2obua">
          <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-white/10 text-amber-300 mr-1 shrink-0" data-id="element-158" data-mp="a7inezgi0gy8">
            <Sparkles className="w-3 h-3" data-id="element-159" data-mp="18ng1k1px0tc" />
          </span>
          <span className="hidden sm:inline text-[15px] font-semibold" data-id="element-160" data-mp="1b9pjp865qe7">
            {t(sloganKey)}
          </span>
          <span className="sm:hidden text-[12px] font-semibold truncate" data-id="element-161" data-mp="txuqnheg5guy">
            {t(sloganKey)}
          </span>
        </span>
  }), [sloganKey, t]);
  return <div className="text-white py-1.5 px-4 text-xs sm:text-sm font-medium relative z-[60] border-b border-[#00311c]/60 bg-[#2E2121]" data-id="element-162" data-mp="f857y8ab8u6x">
      {/*
                                Mobile: justify-between keeps the right-side items pinned to the
                                right edge so they don't shift when the slogan length changes.
                                Desktop: centered.
                              */}
      <div className="max-w-7xl mx-auto flex items-center justify-between md:justify-center gap-3 sm:gap-4" data-id="element-163" data-mp="1mi89gmn4at4a">
        {/* Left slot — slogan only. Active-order tracking moved to the
            Hero WelcomeBack card so it's adjacent to the customer's
            real session context (name, last order, reorder action). */}
        <div className="flex-1 md:flex-none min-w-0 flex items-center min-h-[20px] relative" data-id="element-164" data-mp="13lgirs58xbq7">
          <AnimatePresence mode="wait" data-id="element-165" data-mp="yuqcmcozx4ug">
            <motion.div key={currentSlide.key} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.35,
            ease: 'easeOut'
          }} className="flex items-center whitespace-nowrap min-w-0 max-w-full" data-id="element-166" data-mp="ytp003sc0aam">
              {currentSlide.content}
            </motion.div>
          </AnimatePresence>
        </div>

        {/* Right group — stays static */}
        <div className="flex items-center gap-2 sm:gap-4 shrink-0" data-id="element-167" data-mp="2rig0j4bwmkup">
          <span className="opacity-40" data-id="element-168" data-mp="2whssg3hmui45">|</span>

          <a href="tel:206-619-3742" aria-label={`Call ${PHONE_NUMBER}`} className="inline-flex h-7 items-center gap-1.5 rounded-full px-2 text-xs font-semibold tracking-tight text-white transition-colors hover:bg-white/10 sm:text-sm" data-id="element-169" data-mp="2wghiflxlge4l">
            <Phone className="h-4 w-4 shrink-0" data-id="element-170" data-mp="28szww84xaca2" />
            <span className="whitespace-nowrap" data-id="element-171" data-mp="28uazw5qjng04">{PHONE_NUMBER}</span>
          </a>

        </div>
      </div>
    </div>;
}